import React, { type FunctionComponent } from 'react';
import { ACCOUNT_CREATE_LINK, ACCOUNT_LOGIN_LINK } from '../../../constants/links';
import { type AnalyticsEvent } from '../../../helpers/analytics/analytics.helper';
import { LinkButton } from '../../buttons/link-button/link-button.component';

export type GuestContentViewProps = {
	hasAccount: boolean;
	content?: React.ReactNode;
	message?: string;
	subMessage?: React.ReactNode;
	messageClassName?: string;
	buttonsClassName?: string;
	containerClassName?: string;
	analyticsEventCreateAccount?: AnalyticsEvent;
	analyticsEventLogin?: AnalyticsEvent;
};

export const GuestContentView: FunctionComponent<GuestContentViewProps> = ({
	hasAccount,
	content,
	message = '',
	subMessage,
	messageClassName = 'f5 lh-title font-medium',
	containerClassName = 'flex flex-column pa4',
	buttonsClassName = 'flex flex-column pt4',
	analyticsEventCreateAccount,
	analyticsEventLogin
}) => {
	return hasAccount ? (
		content
	) : (
		<div className={containerClassName}>
			<span className={messageClassName}>{`Create an Account or Login ${message}`}</span>
			{subMessage}
			<div className={buttonsClassName}>
				<LinkButton url={ACCOUNT_CREATE_LINK} analyticsEvent={analyticsEventCreateAccount}>
					Create Account
				</LinkButton>
				<span className="pt3" />
				<LinkButton buttonStyle="SECONDARY" url={ACCOUNT_LOGIN_LINK} analyticsEvent={analyticsEventLogin}>
					Login
				</LinkButton>
			</div>
		</div>
	);
};
